// extracted by css-extract-rspack-plugin
export default {"LoggedDay":"LoggedDaysCalendar_LoggedDay__L5u5e"};